export default __webpack_public_path__ + "static/media/appsumo-logo.30057a0d.png";